var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "telephonic-screening" }, [
    _c(
      "div",
      { staticClass: "grid-x grid-padding-x" },
      [
        _c(
          "div",
          {
            staticClass: "cell small-6",
            staticStyle: {
              "border-right": "solid 1px #D1D1D1",
              padding: "30px 35px"
            }
          },
          [
            _c(
              "div",
              { staticStyle: { width: "90%" } },
              [
                _c("strong", [
                  _vm._v("Invite candidate to a telephonic interview:")
                ]),
                _vm._v(" "),
                _c("p", [
                  _vm._v(
                    "Pick three timeslots that the candidate will be able to pick from"
                  )
                ]),
                _vm._v(" "),
                _c(
                  "form",
                  {
                    staticClass: "pt-0 mt-2",
                    attrs: { action: "", method: "post" }
                  },
                  [
                    _c("input", {
                      attrs: { type: "hidden", name: "_csrfToken" },
                      domProps: { value: _vm.csrfToken }
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-control px-0" }, [
                      _c("label", [_vm._v("Option 1")]),
                      _vm._v(" "),
                      _c("input", {
                        attrs: {
                          disabled: _vm.disabled,
                          type: "datetime-local",
                          name: "telephonic_screening_result[date_first]",
                          required: ""
                        },
                        domProps: {
                          value: _vm.jobApplication.telephonic_screening_result
                            ? _vm.convertDate(
                                _vm.jobApplication.telephonic_screening_result
                                  .date_first
                              )
                            : _vm.convertDate(this.value)
                        }
                      })
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-control px-0" }, [
                      _c("label", [_vm._v("Option 2")]),
                      _vm._v(" "),
                      _c("input", {
                        attrs: {
                          disabled: _vm.disabled,
                          type: "datetime-local",
                          name: "telephonic_screening_result[date_second]",
                          required: ""
                        },
                        domProps: {
                          value: _vm.jobApplication.telephonic_screening_result
                            ? _vm.convertDate(
                                _vm.jobApplication.telephonic_screening_result
                                  .date_second
                              )
                            : _vm.convertDate(this.value)
                        }
                      })
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-control px-0" }, [
                      _c("label", [_vm._v("Option 3")]),
                      _vm._v(" "),
                      _c("input", {
                        attrs: {
                          disabled: _vm.disabled,
                          type: "datetime-local",
                          name: "telephonic_screening_result[date_third]",
                          required: ""
                        },
                        domProps: {
                          value: _vm.jobApplication.telephonic_screening_result
                            ? _vm.convertDate(
                                _vm.jobApplication.telephonic_screening_result
                                  .date_third
                              )
                            : _vm.convertDate(this.value)
                        }
                      })
                    ]),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "button mt-2",
                        attrs: {
                          disabled: _vm.disabled,
                          name: "telephonic_screening",
                          type: "submit"
                        }
                      },
                      [_vm._v("Send Invite")]
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "form",
                  {
                    staticClass: "pt-0 mt-2",
                    attrs: { action: "", method: "post" }
                  },
                  [
                    _c("input", {
                      attrs: { type: "hidden", name: "_csrfToken" },
                      domProps: { value: _vm.csrfToken }
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-control px-0" }, [
                      _c("label", [_vm._v("Set date and time manually")]),
                      _vm._v(" "),
                      _c("input", {
                        attrs: {
                          disabled: _vm.disabled,
                          type: "datetime-local",
                          name: "telephonic_screening_result[date_first]",
                          required: ""
                        },
                        domProps: {
                          value: _vm.jobApplication.telephonic_screening_result
                            ? _vm.convertDate(
                                _vm.jobApplication.telephonic_screening_result
                                  .date_first
                              )
                            : _vm.convertDate(this.value)
                        }
                      })
                    ]),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "button mt-2",
                        attrs: {
                          disabled: _vm.disabled,
                          name: "telephonic_screening_manually",
                          type: "submit"
                        }
                      },
                      [_vm._v("Set time manually")]
                    )
                  ]
                ),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                _c("Cv", {
                  attrs: {
                    jobApplication: _vm.jobApplication,
                    module: _vm.module,
                    "div-class": "small-10",
                    "trait-statements-by-cluster": _vm.traitStatementsByCluster
                  }
                })
              ],
              1
            )
          ]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "cell small-6 p-4" }, [
          _c(
            "form",
            { attrs: { method: "post" }, on: { submit: _vm.disablePassBtn } },
            [
              _c("input", {
                attrs: { type: "hidden", name: "_csrfToken" },
                domProps: { value: _vm.csrfToken }
              }),
              _vm._v(" "),
              _c("input", {
                attrs: { type: "hidden", name: "fail_reason" },
                domProps: { value: _vm.fail_reason }
              }),
              _vm._v(" "),
              _c("input", {
                attrs: { type: "hidden", name: "telephonic_screening_status" },
                domProps: { value: _vm.telephonic_screening_status }
              }),
              _vm._v(" "),
              _c("h4", [_vm._v("Invitation")]),
              _vm._v(" "),
              _vm.jobApplication.telephonic_screening_result
                ? _c("div", [
                    _c("strong", [_vm._v("Invitation Status:")]),
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.jobApplication.telephonic_screening_result
                            .status === "reschedule"
                            ? "The candidate is not available.  Please resend a new invitation."
                            : _vm.jobApplication.telephonic_screening_result
                                .status
                        ) +
                        "\n                    "
                    ),
                    _c("br"),
                    _vm._v(" "),
                    _c("strong", [_vm._v("Date and Time Scheduled:")]),
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.jobApplication.telephonic_screening_result
                            .date_selected
                            ? _vm.convertDate(
                                _vm.jobApplication.telephonic_screening_result
                                  .date_selected,
                                "MMMM D, YYYY H:mm"
                              )
                            : ""
                        ) +
                        "\n                    "
                    ),
                    _c("br")
                  ])
                : _c("div", [
                    _c("strong", [_vm._v("Invitation Status:")]),
                    _vm._v(" Not yet sent\n                    "),
                    _c("br"),
                    _vm._v(" "),
                    _c("strong", [_vm._v("Date and Time Scheduled:")]),
                    _vm._v(" Not yet set\n                    "),
                    _c("br")
                  ]),
              _vm._v(" "),
              _c("strong", [_vm._v("Final Status:")]),
              _vm._v(
                " " +
                  _vm._s(_vm.jobApplication.telephonic_screening_status) +
                  "\n                "
              ),
              _vm.logs !== null && _vm.logs !== ""
                ? _c("span", [
                    _vm._v(
                      "\n                     (Updated By " +
                        _vm._s(_vm.logs.user.first_name) +
                        " " +
                        _vm._s(_vm.logs.user.last_name) +
                        " - " +
                        _vm._s(
                          _vm.convertDate(_vm.logs.created, "YYYY-MM-DD HH:mm")
                        ) +
                        ")\n                "
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "grid-x grid-padding-x" }, [
                _c("div", { staticClass: "cell shrink" }, [
                  _vm.jobApplication.user.country_id === 246
                    ? _c("div", [
                        _c(
                          "button",
                          {
                            ref: "passedButton",
                            staticClass: "button px-5",
                            class: {
                              "d-none": _vm.idVerificationCheck === null
                            },
                            attrs: {
                              type: "submit",
                              disabled: _vm.passBtnDisabled || _vm.disabled
                            }
                          },
                          [_vm._v("Pass")]
                        ),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            staticClass: "button px-5",
                            class: {
                              "d-none": _vm.idVerificationCheck !== null
                            },
                            attrs: { disabled: _vm.disabled, type: "button" },
                            on: {
                              click: function($event) {
                                return _vm.toggleModal("checkIdInfoModal")
                              }
                            }
                          },
                          [_vm._v("Pass")]
                        )
                      ])
                    : _c("div", [
                        _c(
                          "button",
                          {
                            ref: "passedButton",
                            staticClass: "button px-5",
                            attrs: {
                              type: "submit",
                              disabled: _vm.passBtnDisabled || _vm.disabled
                            }
                          },
                          [_vm._v("Pass")]
                        )
                      ])
                ]),
                _vm._v(" "),
                _c("div", [
                  _c("button", {
                    ref: "failedButton",
                    staticClass: "d-none",
                    attrs: {
                      value: "failed",
                      name: "telephonic_screening_status"
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "button alert px-5",
                      attrs: { disabled: _vm.disabled, type: "button" },
                      on: {
                        click: function($event) {
                          return _vm.toggleModal("failModal")
                        }
                      }
                    },
                    [_vm._v("Fail")]
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "cell shrink" }, [
                  _c(
                    "button",
                    {
                      staticClass: "button recycle px-5",
                      attrs: { disabled: _vm.disabled, type: "button" },
                      on: {
                        click: function($event) {
                          return _vm.toggleModal("recycleModal")
                        }
                      }
                    },
                    [_vm._v("Recycle")]
                  )
                ])
              ]),
              _vm._v(" "),
              _c("hr"),
              _vm._v(" "),
              _c("h4", { staticClass: "mt-4" }, [
                _vm._v("Screening Questions")
              ]),
              _vm._v(" "),
              _vm._l(
                _vm.jobApplication.job.requisition.person_specification
                  .interview_questions,
                function(interviewQuestion, index) {
                  return _c("div", { key: "row" + index }, [
                    interviewQuestion.phase == "Telephonic Screening"
                      ? _c("div", [
                          _c("input", {
                            attrs: {
                              type: "hidden",
                              name:
                                "interview_answers[" +
                                index +
                                "][job_application_id]"
                            },
                            domProps: { value: _vm.jobApplication.id }
                          }),
                          _vm._v(" "),
                          _c("input", {
                            attrs: {
                              type: "hidden",
                              name:
                                "interview_answers[" +
                                index +
                                "][interview_question_id]"
                            },
                            domProps: { value: interviewQuestion.id }
                          }),
                          _vm._v(" "),
                          _vm.interviewAnswers[interviewQuestion.id]
                            ? _c("div", [
                                _c("input", {
                                  attrs: {
                                    type: "hidden",
                                    name: "interview_answers[" + index + "][id]"
                                  },
                                  domProps: {
                                    value:
                                      _vm.interviewAnswers[
                                        interviewQuestion.id
                                      ]["id"]
                                  }
                                })
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "d-flex align-items-center gap-1" },
                            [
                              _c("p", [
                                _c("strong", [_vm._v(_vm._s(index + 1) + ". ")])
                              ]),
                              _vm._v(" "),
                              _c("span", {
                                domProps: {
                                  innerHTML: _vm._s(interviewQuestion.title)
                                }
                              })
                            ]
                          ),
                          _vm._v(" "),
                          interviewQuestion.answer_type == "yes_no"
                            ? _c("div", [
                                _c("input", {
                                  attrs: {
                                    disabled: _vm.disabled,
                                    type: "radio",
                                    value: "1",
                                    name:
                                      "interview_answers[" + index + "][answer]"
                                  },
                                  domProps: {
                                    checked:
                                      _vm.interviewAnswers[
                                        interviewQuestion.id
                                      ] &&
                                      _vm.interviewAnswers[
                                        interviewQuestion.id
                                      ]["answer"] == 1
                                  }
                                }),
                                _vm._v(" "),
                                _c("label", [
                                  _vm._v(
                                    "\n                                Yes\n                            "
                                  )
                                ]),
                                _vm._v(" "),
                                _c("input", {
                                  attrs: {
                                    disabled: _vm.disabled,
                                    type: "radio",
                                    value: "0",
                                    name:
                                      "interview_answers[" + index + "][answer]"
                                  },
                                  domProps: {
                                    checked:
                                      _vm.interviewAnswers[
                                        interviewQuestion.id
                                      ] &&
                                      _vm.interviewAnswers[
                                        interviewQuestion.id
                                      ]["answer"] == 0
                                  }
                                }),
                                _vm._v(" "),
                                _c("label", [
                                  _vm._v(
                                    "\n                                No\n                            "
                                  )
                                ])
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          interviewQuestion.answer_type == "free"
                            ? _c("div", [
                                _vm.interviewAnswers[interviewQuestion.id]
                                  ? _c("textarea", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value:
                                            _vm.interviewAnswers[
                                              interviewQuestion.id
                                            ]["answer"],
                                          expression:
                                            "interviewAnswers[interviewQuestion.id]['answer']"
                                        }
                                      ],
                                      attrs: {
                                        rows: "40",
                                        disabled: _vm.disabled,
                                        name:
                                          "interview_answers[" +
                                          index +
                                          "][answer]"
                                      },
                                      domProps: {
                                        value:
                                          _vm.interviewAnswers[
                                            interviewQuestion.id
                                          ]["answer"]
                                      },
                                      on: {
                                        input: function($event) {
                                          if ($event.target.composing) {
                                            return
                                          }
                                          _vm.$set(
                                            _vm.interviewAnswers[
                                              interviewQuestion.id
                                            ],
                                            "answer",
                                            $event.target.value
                                          )
                                        }
                                      }
                                    })
                                  : _c("textarea", {
                                      attrs: {
                                        rows: "40",
                                        disabled: _vm.disabled,
                                        name:
                                          "interview_answers[" +
                                          index +
                                          "][answer]"
                                      }
                                    })
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          interviewQuestion.answer_type == "rating"
                            ? _c(
                                "div",
                                [
                                  _c("component-star-rating", {
                                    attrs: {
                                      disabled: _vm.disabled,
                                      name:
                                        "interview_answers[" +
                                        index +
                                        "][answer]",
                                      "default-rating": parseInt(
                                        _vm.interviewAnswers[
                                          interviewQuestion.id
                                        ]
                                          ? _vm.interviewAnswers[
                                              interviewQuestion.id
                                            ]["answer"]
                                          : 0
                                      )
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c("br")
                        ])
                      : _vm._e()
                  ])
                }
              ),
              _vm._v(" "),
              _c("input", {
                attrs: {
                  type: "hidden",
                  name: "interview_scores[0][job_application_id]`"
                },
                domProps: { value: _vm.jobApplication.id }
              }),
              _vm._v(" "),
              _c("input", {
                attrs: {
                  type: "hidden",
                  name: "interview_scores[0][phase]`",
                  value: "Telephonic Screening"
                }
              }),
              _vm._v(" "),
              _c("input", {
                attrs: { type: "hidden", name: "interview_scores[0][id]`" },
                domProps: {
                  value: _vm.interviewScores["Telephonic Screening"]
                    ? _vm.interviewScores["Telephonic Screening"]["id"]
                    : null
                }
              }),
              _vm._v(" "),
              _c("div", { staticClass: "form-control" }, [
                _c("label", [_vm._v("Pitch:")]),
                _vm._v(" "),
                _c("input", {
                  attrs: {
                    disabled: _vm.disabled,
                    type: "number",
                    step: "1",
                    min: "0",
                    max: "4",
                    required: "",
                    name: "interview_scores[0][pitch]"
                  },
                  domProps: {
                    value: _vm.interviewScores["Telephonic Screening"]
                      ? _vm.interviewScores["Telephonic Screening"]["pitch"]
                      : 0
                  }
                })
              ]),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _c("div", { staticClass: "form-control" }, [
                _c("label", [_vm._v("Pace:")]),
                _vm._v(" "),
                _c("input", {
                  attrs: {
                    disabled: _vm.disabled,
                    type: "number",
                    step: "1",
                    min: "0",
                    max: "4",
                    required: "",
                    name: "interview_scores[0][pace]"
                  },
                  domProps: {
                    value: _vm.interviewScores["Telephonic Screening"]
                      ? _vm.interviewScores["Telephonic Screening"]["pace"]
                      : 0
                  }
                })
              ]),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _c("div", { staticClass: "form-control" }, [
                _c("label", [_vm._v("Tone:")]),
                _vm._v(" "),
                _c("input", {
                  attrs: {
                    disabled: _vm.disabled,
                    type: "number",
                    step: "1",
                    min: "0",
                    max: "4",
                    required: "",
                    name: "interview_scores[0][tone]"
                  },
                  domProps: {
                    value: _vm.interviewScores["Telephonic Screening"]
                      ? _vm.interviewScores["Telephonic Screening"]["tone"]
                      : 0
                  }
                })
              ]),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _c("div", { staticClass: "form-control" }, [
                _c("label", [_vm._v("Clarity:")]),
                _vm._v(" "),
                _c("input", {
                  attrs: {
                    disabled: _vm.disabled,
                    type: "number",
                    step: "1",
                    min: "0",
                    max: "4",
                    required: "",
                    name: "interview_scores[0][clarity]"
                  },
                  domProps: {
                    value: _vm.interviewScores["Telephonic Screening"]
                      ? _vm.interviewScores["Telephonic Screening"]["clarity"]
                      : 0
                  }
                })
              ]),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _c("div", { staticClass: "form-control" }, [
                _c("label", [_vm._v("Score:")]),
                _vm._v(" "),
                _c("input", {
                  attrs: {
                    disabled: _vm.disabled,
                    type: "number",
                    step: "1",
                    min: "0",
                    max: "4",
                    required: "",
                    name: "interview_scores[0][score]"
                  },
                  domProps: {
                    value: _vm.interviewScores["Telephonic Screening"]
                      ? _vm.interviewScores["Telephonic Screening"]["score"]
                      : 0
                  }
                })
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-control" }, [
                _c("div", { staticClass: "grid-x grid-padding-x" }, [
                  _c("div", { staticClass: "cell shrink" }, [
                    _vm.jobApplication.user.country_id === 246
                      ? _c("div", [
                          _c(
                            "button",
                            {
                              ref: "passedButton",
                              staticClass: "button px-5",
                              class: {
                                "d-none": _vm.idVerificationCheck === null
                              },
                              attrs: {
                                disabled: _vm.disabled,
                                type: "submit",
                                name: "telephonic_screening_status",
                                value: "passed"
                              }
                            },
                            [
                              _vm._v(
                                "\n                                    Pass\n                                "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass: "button px-5",
                              class: {
                                "d-none": _vm.idVerificationCheck !== null
                              },
                              attrs: {
                                disabled: _vm.disabled,
                                type: "button",
                                value: "passed"
                              },
                              on: {
                                click: function($event) {
                                  return _vm.toggleModal("checkIdInfoModal")
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n                                    Pass\n                                "
                              )
                            ]
                          )
                        ])
                      : _c("div", [
                          _c(
                            "button",
                            {
                              ref: "passedButton",
                              staticClass: "button px-5",
                              attrs: {
                                disabled: _vm.disabled,
                                type: "submit",
                                name: "telephonic_screening_status",
                                value: "passed"
                              }
                            },
                            [
                              _vm._v(
                                "\n                                    Pass\n                                "
                              )
                            ]
                          )
                        ])
                  ]),
                  _vm._v(" "),
                  _c("div", [
                    _c("button", {
                      ref: "failedButton",
                      staticClass: "d-none",
                      attrs: {
                        value: "failed",
                        name: "telephonic_screening_status"
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "button alert px-5",
                        attrs: { disabled: _vm.disabled, type: "button" },
                        on: {
                          click: function($event) {
                            return _vm.toggleModal("failModal")
                          }
                        }
                      },
                      [_vm._v("Fail")]
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "cell shrink" }, [
                    _c(
                      "button",
                      {
                        staticClass: "button recycle px-5",
                        attrs: { disabled: _vm.disabled, type: "button" },
                        on: {
                          click: function($event) {
                            return _vm.toggleModal("recycleModal")
                          }
                        }
                      },
                      [_vm._v("Recycle")]
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "cell shrink" }, [
                    _c(
                      "button",
                      {
                        staticClass: "button",
                        attrs: { type: "button" },
                        on: {
                          click: function($event) {
                            return _vm.saveInterviewAnswersManual()
                          }
                        }
                      },
                      [_vm._v("Save Interview Answers")]
                    )
                  ])
                ])
              ])
            ],
            2
          )
        ]),
        _vm._v(" "),
        _c("recycle-modal", {
          ref: "recycleModal",
          attrs: {
            "job-application": _vm.jobApplication,
            "csrf-token": _vm.csrfToken
          }
        }),
        _vm._v(" "),
        _c("fail-modal", {
          ref: "failModal",
          attrs: { "job-application": _vm.jobApplication },
          on: { submit: _vm.fail }
        }),
        _vm._v(" "),
        _c("check-id-info-modal", {
          ref: "checkIdInfoModal",
          attrs: { "job-application": _vm.jobApplication },
          on: { submit: _vm.pass }
        })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d434a024", { render: render, staticRenderFns: staticRenderFns })
  }
}